import { createPinia, defineStore, PiniaPluginContext } from "pinia";
import { PiniaDebounce } from "@pinia/plugin-debounce";
import pDebounce from "p-debounce";
import { useApiStore } from "./api";
import { useAccountStore } from "./account";
import { initializeEntraAuth } from "@/auth/entraAuthService";
import { initializeNativeAuth } from "@/auth/nativeAuthService";

export const pinia = createPinia();

pinia
  .use(({ app, store }: PiniaPluginContext) => {
    store.apiClient = app.config.globalProperties.$apiClient;
  })
  .use(PiniaDebounce(pDebounce));

export const useRootStore = defineStore("RootStore", {
  actions: {
    async init() {
      const api = useApiStore();
      const account = useAccountStore();

      // Feature flags carry the Entra auth config, so they must load first; MSAL
      // is then initialized (processing any sign-in redirect) before the account
      // calls run, so their requests can carry a bearer token.
      await api.init();
      await initializeEntraAuth(api.options);
      await initializeNativeAuth(api.options);
      await account.init();
    },
  },
});
